import StepExternalMapping from "../step/step_external_mapping.js";
import EntityTypesAP214 from "./AP214E3_2010_gen/entity_types_ap214.gen.js";
/**
 * IFC external step mapping
 */
export default class AP214StepExternalMapping extends StepExternalMapping {
    /**
     * Construct this external mapping.
     *
     * @param localID The local ID for this.
     * @param internalReference_ The internal reference matching this.
     * @param model The model matching this.
     */
    constructor(localID, internalReference_, model) {
        super(localID, internalReference_, model);
    }
}
AP214StepExternalMapping.query = [EntityTypesAP214.EXTERNALMAPPINGCONTAINER];
AP214StepExternalMapping.expectedType = EntityTypesAP214.EXTERNALMAPPINGCONTAINER;
